import Request from "./request";

const Settings = "/settings";

export default {
  async getSettings() {
    return Request.get(Settings);
  }
};
